<template>
  <section class="w-full bg-gradient-to-b from-blue-900 to-blue-800">
    <div class="container mx-auto px-4 py-24 flex flex-col items-center text-center">
      <h1 class="text-4xl md:text-5xl font-bold text-white mb-6">
        Professional Property Management in NYC
      </h1>
      <p class="text-xl text-blue-100 max-w-3xl mb-10">
        Fairmont Park LLC provides exceptional property management services
        with a focus on client satisfaction and property value optimization.
      </p>
      <router-link
          to="/contact"
          class="px-8 py-3 bg-amber-500 text-white rounded-md hover:bg-amber-600 transition-colors shadow-lg"
      >
        Contact Us
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroGlobal"
}
</script>